export default function getSubdomain() {
	const { hostname } = window.location
	const parts = hostname.split(".")
	if (parts.length !== 3) {
		return ""
	} else {
		return parts[0]
	}
}
